import ToolBar from "../../Components/ToolBar/ToolBar";
import { toast } from "react-toastify";
import { useContext, useState, useRef, useEffect } from "react";
import AppContext from "../../Context/AppContext";
import {
  RestSkuBatchInventoryListRequest,
  SKUBatchInventorySearchCriteria,
  PageListBean,
  BatchInventorySummaryDataPrintRequest,
  RestReadRequest,
  FabricStyleSearchCriteria,
  RestFabricStyleListBeanRequest,
} from "../../Ds/ds";
import { RestReportBean } from "../../Ds/client_ds";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  ColumnDefinition,
} from "../../Utils/util";
import PageBar from "../../Components/ToolBar/PageBar";
import Loader from "../../Components/Loder";
import InputTextBox from "../../Components/Base/InputTextBox";
import CustomButton from "../../Components/Base/CustomButton";
import service from "../../Services/Service";
import {
  TOAST_ERROR,
  TOAST_SUCESS,
  TOAST_THEME_COLOR,
  TOAST_WARN,
} from "../../Utils/appConstants";
import InValidAccess from "../../Components/InValidAccess";
import { SecurityAccessManager } from "../../Security/SecurityAccessManager";
import NoData from "../../Components/NoData";
import CustomTable from "../../Components/Base/CustomTable";
import ViewToggle from "../../Components/ViewToggle";
import MobileCardTable from "../../Components/MobileCardTable";


export default function SkuBatchInquiry() {
  const { token, setisSessionExpeired, session } = useContext(AppContext);
 const [view, setView]               = useState(1); // 1 = list, 2 = grid
  const [code, setCode] = useState("");
  const [skuInventories, setSkuInventories] = useState([]);
  const [criteria, setCriteria] = useState(
    new SKUBatchInventorySearchCriteria()
  );
  const title = "SKU Batch Inventory";
  const [pageSize, setPageSize] = useState(500);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowPdf, setIsShowPdf] = useState(false);
  const [isShowExcel, setIsShowExcel] = useState(false);
  const [disable, setDisable] = useState(false);
  const [isAccessible, setIsAccessible] = useState(false);
  const inputRef = useRef(null);
  const buttonRef = useRef(null);
    const [isMobile, setIsMobile]         = useState(window.innerWidth <= 768);


  
 const fabricStyleCodeRef                                              = useRef(null);
  // Replaced external FabricStyleLookupHandler with inline FabricStyleLookupModal
  const [isFabricLookupOpen, setIsFabricLookupOpen]                     = useState(false);
  const [fabricPageListForAutoCompleteList, setFabricPageListForAutoCompleteList] = useState([]);
  // Start as false — the dropdown must be hidden until the user actually types
  const [showAutoCompleteFabricCodeList, setShowAutoCompleteFabricCodeList] = useState(false);
  const [isAllowFabricRead, setIsAllowFabricRead]                       = useState(false);

  useEffect(() => {
     function handleResize() {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      // Only auto-switch view on resize; let the manual toggle
      // (listViewHandler / gridViewHandler) win otherwise.
      setView((prevView) => (mobile ? 2 : prevView === 2 ? 1 : prevView));
    }
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function getDefaultView() {
    return window.innerWidth <= 768 ? 1 : 2;
  }

  const listViewHandler = () => {
    setView(1);
  };
  const gridViewHandler = () => {
    setView(2);
  };

  const setFocus = () => {
    if (inputRef.current != null) inputRef.current.focus();
  };
  useEffect(() => {
    setFocus();
  }, []);
  const notify = (type, msg, theme) => {
    if (type === 1)
      toast.info(msg, {
        theme: theme,
      });
    else if (type === 2)
      toast.error(msg, {
        theme: theme,
      });
    else if (type === 3)
      toast.success(msg, {
        theme: theme,
      });
    else if (type === 4)
      toast.warn(msg, {
        theme: theme,
      });
    else toast(msg);
  };
  const errorCallBack = (error) => {
    setIsLoading(false);
    notify(TOAST_ERROR, error.message);
  };
  const handleReportResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (response.data != null) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (response.data.reportResult != null) {
          if (!isEmptyString(response.data.reportResult.reportFileID)) {
            let reportFilePath = response.data.reportResult.reportFileID;
            window.open(
              `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_REPORT_PATH}` +
                reportFilePath
            );
          }
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => {
            msg_List.push(info.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_SUCESS, msg);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };
  const generateReport = (type) => {
    const criteria = new SKUBatchInventorySearchCriteria();
    criteria.fabricStyleCodeContains = code;
    criteria.fabricStyleCodeStartsWith = code;
    criteria.companyCode = process.env.REACT_APP_COMPANY;
    if (!isEmpty(session)) {
      const { entityCode, code } = session;
      if (!isEmptyString(entityCode))
        criteria.logisticCustomerCode = entityCode;
      if (!isEmptyString(code)) criteria.customerUserCode = code;
    }
    const reportBean = new RestReportBean();
    reportBean.reportType = type;
    const request = new BatchInventorySummaryDataPrintRequest();
    request.criteria = criteria;
    request.reportBean = reportBean;
    const path = "generateBatchInventorySummaryDataPrintReport";
    service(token, path, request, handleReportResponse, errorCallBack);
  };
  const PDFHandler = () => {
    if (
      SecurityAccessManager.SkuBatchInventoryInquiryPDFReport_IsAccessible()
    ) {
      setIsLoading(true);
      generateReport(1);
    } else {
      setIsAccessible(true);
    }
  };
  const ExcelHandler = () => {
    if (
      SecurityAccessManager.SkuBatchInventoryInquiryExcelReport_IsAccessible()
    ) {
      setIsLoading(true);
      generateReport(2);
    } else {
      setIsAccessible(true);
    }
  };
  const ResetHandler = () => {
    setCode("");
    setSkuInventories([]);
    setDisable(false);
    setIsShowExcel(false);
    setIsShowPdf(false);
    setFocus();
  };
  const handleResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (
          !isEmpty(response.data.skuBatchInventoryPageList) &&
          !isEmptyArray(
            response.data.skuBatchInventoryPageList.skuBatchInventories
          )
        ) {
          setSkuInventories(
            response.data.skuBatchInventoryPageList.skuBatchInventories
          );
          if (response.data.skuBatchInventoryPageList.totalCount != null) {
            const total_Count =
              response.data.skuBatchInventoryPageList.totalCount;
            const maxPage = Math.ceil(total_Count / pageSize);
            setTotalCount(total_Count);
            setIsShowExcel(true);
            setIsShowPdf(true);
            setMaxPage(maxPage);
          }
          if (response.data.skuBatchInventoryPageList.currentPage != null) {
            setPage(response.data.skuBatchInventoryPageList.currentPage);
          }
        }
        if (
          !isEmpty(response.data.skuBatchInventoryPageList) &&
          isEmptyArray(
            response.data.skuBatchInventoryPageList.skuBatchInventories
          )
        ) {
          notify(TOAST_WARN, "No Data Found");
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => {
            msg_List.push(info.messageDescription);
          });
          msg = msg_List.toString();
          // notify(TOAST_SUCESS, msg);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };
  const ExecuteHandler = () => {
    loadPage(1);
  };
  const loadPrevious = () => {
    if (page > 1) {
      const pagenumber = parseInt(page) - 1;
      loadPage(pagenumber);
    }
  };
  const loadNext = () => {
    if (maxPage > page) {
      const pagenumber = parseInt(page) + 1;
      loadPage(pagenumber);
    }
  };
  const loadFirst = () => {
    loadPage(1);
  };
  const loadLast = () => {
    loadPage(maxPage);
  };
  const loadPage = (id) => {
    if (SecurityAccessManager.SkuBatchInventoryInquiry_IsAccessible()) {
      setSkuInventories([]);
      setIsLoading(true);
      const request = new RestSkuBatchInventoryListRequest();
      const criteria_temp = new SKUBatchInventorySearchCriteria();
      criteria_temp.companyCode = process.env.REACT_APP_COMPANY;
     // criteria_temp.fabricStyleCodeContains = code;
        criteria_temp.fabricStyleCode = criteria.fabricStyleCode;
      criteria_temp.isExcludeNonWarehouseInventory = true;
      criteria_temp.fetchQuantityAvailableLinesOnly = true;
      if (!isEmpty(session)) {
        const { entityCode, code } = session;
        if (!isEmptyString(entityCode))
          criteria_temp.logisticCustomerCode = entityCode;
        if (!isEmptyString(code)) criteria_temp.customerUserCode = code;
      }
      const pageInput = new PageListBean();
      pageInput.currentPage = id;
      pageInput.pageSize = pageSize;
      request.searchCriteria = criteria_temp;
      request.pageInput = pageInput;
      const path = "getSkuBatchInventoryPageList";
      service(token, path, request, handleResponse, errorCallBack);
    } else {
      setIsAccessible(true);
    }
  };
  const enterKeyHandler = (e) => {
    loadFirst();
  };
  const buttonHandler = (e) => {
    loadFirst();
  };
  const onChange = (e) => {
    setCode(e.target.value.toUpperCase());
  };
  const onClose = () => {
    setIsAccessible(false);
  };
  const Columns = () => {
    const _columns = new Array();

    _columns.push(
      new ColumnDefinition()
        .setDetails("Item", "fabricStyleCode", true)

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleName", true)

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "10", "", "wt-3", "wt-3")
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Inventory", "rollSkuNumber", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Lot", "vendorBatchNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("RollNumber", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty", "onHandQuantity", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );

    return _columns;
  };



    
  // ── Fabric/Item lookup handlers ────────────────────────────────────────────
  const onFabricCodeChange = (e) => {
    const fabricStyleCode = e.target.value.toUpperCase();
    if (!fabricStyleCode) {
      // Field cleared — hide dropdown
      setShowAutoCompleteFabricCodeList(false);
      setFabricPageListForAutoCompleteList([]);
      setIsAllowFabricRead(false);
    } else {
      // Characters typed — show dropdown and kick off the search-as-you-type call
      setShowAutoCompleteFabricCodeList(true);
      readFabricBySearchString(fabricStyleCode);   // pass the already-uppercased value
      setIsAllowFabricRead(false);
    }
  setCriteria((prev) => {
    const next = { ...prev, [e.target.name]: fabricStyleCode };
  //  criteriaRef.current = next;   // uncommented
    return next;
  });
  };

  const onfabricBlur = (e) => {
    // On blur, do a direct style read to validate the typed code —
    // mirrors the readandsetFabricStyleDetail call triggered by blur in
    // SalesOrderMaintenanceModule (the same RestReadRequest / readFabricStyle flow).
    setTimeout(() => {
      if (!isAllowFabricRead && e.target.value) {
        readFabricByCode(e.target.value);
      }
    }, 100);
  };

  const onfabricKeyDown = (e) => {
    // F2 (113) or Escape (27) — allow direct read, suppress blur autocomplete
    if (e.keyCode === 113 || e.keyCode === 27) {
      setIsAllowFabricRead(true);
    }
  };

  const fabricenterKeyEventHandler = (e) => {

    
    const fabricStyleCode = e.target.value;
    setShowAutoCompleteFabricCodeList(false);
    setFabricPageListForAutoCompleteList([]);
    setIsAllowFabricRead(false);
 setCriteria((prev) => {
    const next = { ...prev, fabricStyleCode: fabricStyleCode.toUpperCase() };
   // criteriaRef.current = next;   // uncommented
    return next;
  });
    // On Enter, do a direct read via readFabricStyle to validate the code —
    // mirrors fabricenterKeyEventHandler → readandsetFabricStyleDetail in
    // SalesOrderMaintenanceModule.
    if (fabricStyleCode) readFabricByCode(fabricStyleCode);
    // Advance focus to the Color field
    enterKeyHandler("fabricStyleCode");
  };

  // Called when user picks a row inside FabricStyleLookupModal
  const onFabricLookupSelect = (item) => {
  setCriteria((prev) => {
    const next = { ...prev, fabricStyleCode: item.code };
  //  criteriaRef.current = next;   // uncommented
    return next;
  });
    setFabricPageListForAutoCompleteList([]);
    setShowAutoCompleteFabricCodeList(false);
    setIsAllowFabricRead(false);
    readFabricByCode(item.code);
  };
  // Mirrors readandsetFabricStyleDetail() in SalesOrderMaintenanceModule:
  //   • Builds RestReadRequest with companyCode, code, isLoadChildren=true
  //   • Calls FabricStyleService.readFabricStyle
  //   • On success: reads response.data.fabricStyle to confirm the style exists
  //   • On error: silently clears the autocomplete list (no blocking alert)
  const readFabricByCode = (fabricStyleCode) => {
    if (!fabricStyleCode) return;
    const input = new RestReadRequest();
    input.companyCode   = process.env.REACT_APP_COMPANY;
    input.code          = fabricStyleCode.toUpperCase();
    input.isLoadChildren = true;
    service(token,"readFabricStyle",
      input,
      (response) => {
        
        const fabricStyle = response?.data?.fabricStyle;
        if (!fabricStyle) {
          setFabricPageListForAutoCompleteList([]);
          // setColorList([]);
          // setShowAutoCompleteColorList(false);
          return;
        }
        // ── Populate color dropdown from fabricStyle.colors ────────────────
        // Mirrors fabricStyleSelected() in SalesOrderMaintenanceModule:
        //   builds a list of { code, description } from active colors.
        // const colors = fabricStyle.colors || [];
        // const activeColors = colors
        //   // .filter((c) => c.isActive)
        //   .map((c) => ({
        //     code:        c.fabricStyleColorCode,
        //     description: c.fabricStyleColorName || c.fabricStyleColorCode,
        //   }));

        //  setFabric(fabricStyle);

        // if (activeColors.length === 1) {
        //   // Auto-select the only active color
        //   setCriteria((prev) => {
        //     const next = { ...prev, fabricStyleColorCode: activeColors[0].code };
        //     criteriaRef.current = next;
        //     return next;
        //   });
        //   setColorList([]);
        //   setShowAutoCompleteColorList(false);
        // } else {
        //   setColorList(activeColors);
        //   // Show the dropdown only if there are multiple colors and no value typed yet
        //   setShowAutoCompleteColorList(activeColors.length > 0);
        // }
            setCriteria((prev) => {
      const next = { ...prev, [fabricStyleCode]: fabricStyleCode };
            if (!fabricStyleCode) {
        // Item/Fabric cleared — clear the corresponding color code too
      //  next.fabricStyleColorCode = "";
      }

      //criteriaRef.current = next;
      return next;
    });
      },
      (error) => {
        setFabricPageListForAutoCompleteList([]);
     //   setColorList([]);
        notify(TOAST_ERROR, error.message);
      },
    );
  };

  const displayAutoCompleteFabricCodeList = (show) => {
    setShowAutoCompleteFabricCodeList(show);
  };

  const readFabricBySearchString = (searchString) => {
    const searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = process.env.REACT_APP_COMPANY;
    // Code prefix must be uppercase to hit the server index; name search is case-tolerant
    searchCriteria.fabricStyleCodeStartsWith = searchString.toUpperCase();
    searchCriteria.fabricStyleNameStartsWith = searchString;
    const pageInput = new PageListBean();
    pageInput.pageSize = 100;
    const input = new RestFabricStyleListBeanRequest();
    input.companyCode    = process.env.REACT_APP_COMPANY;
    input.pageInput      = pageInput;
    input.code           = searchString.toUpperCase();
    input.searchCriteria = searchCriteria;
    service(
      token,
      "getActiveFabricStylesForAutoComplete",
      input,
      (response) => {
        const styles = response?.data?.fabricStylePageList?.fabricStyles || [];
        const list = styles
          .filter((s) => s.isActive)
          .map((s) => ({ code: s.fabricStyleCode, description: s.fabricStyleName }));
        setFabricPageListForAutoCompleteList(list);
      },
      // Search-as-you-type errors should clear silently, not toast the user
      () => setFabricPageListForAutoCompleteList([]),
    );
  };



  return (
    <>
      {isLoading ? <Loader /> : null}
      <ToolBar
        title={title}
        PDFHandler={PDFHandler}
        ExcelHandler={ExcelHandler}
        ResetHandler={ResetHandler}
        ExecuteHandler={ExecuteHandler}
        isShowPdf={isShowPdf}
        isShowExcel={isShowExcel}
      />

      <div className="card-body">
        <div className="row">
          <div className="form-group col-5">
            <InputTextBox
              // value={code}
              // required={true}
              // name="code"
              // placeholder={"Enter item code"}
              // label={"Item Code"}
              // enterKeyHandler={enterKeyHandler}
              // onChange={onChange}
              // disable={disable}
              // inputRef={inputRef}
                 onKeyDown={onfabricKeyDown}
                  onValueChangeOnBlur={onfabricBlur}
                  valueChangeOnBlur={true}
                  ref={fabricStyleCodeRef}
                  name="fabricStyleCode"
                  onChange={onFabricCodeChange}
                  value={criteria.fabricStyleCode}
                  enterKeyEventHandler={fabricenterKeyEventHandler}
                  autoCompleteListData={fabricPageListForAutoCompleteList}
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={displayAutoCompleteFabricCodeList}
                  showAutoCompleteList={showAutoCompleteFabricCodeList}
                  isMandatory={true}
                 label={"Item Code"}
                  placeholder="Item"
                  lookupList={fabricPageListForAutoCompleteList}
                  showLookupDropdown={showAutoCompleteFabricCodeList && fabricPageListForAutoCompleteList.length > 0}
                  onLookupSelect={(item) => onFabricLookupSelect(item)}
                  onHideLookupDropdown={() => setShowAutoCompleteFabricCodeList(false)}
                    disable={disable}
            />
          </div>
          <div className="form-group col-fit">
            <CustomButton
              buttonHandler={buttonHandler}
              disable={disable}
              buttonRef={buttonRef}
              label={"Fetch"}
            />
          </div>
        </div>
      </div>
      {!isEmptyArray(skuInventories) ? (
        <PageBar
          loadFirst={loadFirst}
          loadNext={loadNext}
          loadPrevious={loadPrevious}
          loadLast={loadLast}
          page={page}
        />
      ) : null}
      {!isEmptyArray(skuInventories) ? (
        <ViewToggle
          listViewHandler={listViewHandler}
          gridViewHandler={gridViewHandler}
        />
      ) : null}
      {!isEmptyArray(skuInventories) ? (
        <div className="card-body">
          <div className="card-title">
            <h1>SKU Inventory Details</h1>
          </div>
          <div className="list-wrap">
            {view === 1 ? (
              <>
                {" "}
                <CustomTable
                  columns={Columns}
                  data={skuInventories}
                  isShowFullScreen={true}
                />
              </>
            ) : (
              // <div className="sku-list">
              //   {skuInventories.map((sku, idx) => {
              //     return (
              //       <div className="sku-card" key={idx}>
              //         <div className="sku-card-head">
              //           <div className="sku-card-title">
              //             <span className="_imp">{sku.fabricStyleCode}</span>
              //             <span className="sku-card-name">
              //               ({sku.fabricStyleName})
              //             </span>
              //           </div>
              //           <div className="sku-card-subtitle">
              //             <span>{sku.fabricStyleColorCode}</span>
              //             <span className="imp">{sku.locationCode}</span>
              //           </div>
              //         </div>
              //         <div className="sku-card-grid">
              //           <div className="sku-row">
              //             <span className="sku-label">OnHand Qty</span>
              //             <span className="sku-value">
              //               (
              //               <span className="_imp">
              //                 {toCommaSeperatedAmount(sku.onHandQuantity)}
              //               </span>
              //               ) {sku.uomCode}
              //             </span>
              //           </div>
              //           <div className="sku-row">
              //             <span className="sku-label">SKU Number</span>
              //             <span className="sku-value">{sku.skuNumber}</span>
              //           </div>
              //           <div className="sku-row">
              //             <span className="sku-label">Roll / SKU</span>
              //             <span className="sku-value">
              //               {sku.rollNumber} / {sku.rollSkuNumber}
              //             </span>
              //           </div>
              //           <div className="sku-row">
              //             <span className="sku-label">PO / PR</span>
              //             <span className="sku-value imp">
              //               {sku.purchaseOrderNumber} /{" "}
              //               {sku.purchaseOrderReceiptNumber}
              //             </span>
              //           </div>
              //           <div className="sku-row">
              //             <span className="sku-label">Lot / Bin</span>
              //             <span className="sku-value">
              //               {sku.vendorBatchNumber} / {sku.aisleInfoText}
              //             </span>
              //           </div>
              //         </div>
              //       </div>
              //     );
              //   })}
              // </div>

              <MobileCardTable
                  columns={Columns()}
                  data={skuInventories}
                  codeAccessor="code"
                  // subAccessor="customerName"
                  // dateAccessor="createdDate"
                  // statusAccessor="orderStatus"
                  // onPDF={(row) => PDFHandler(row.code)}
                  // onMoreOption={(row) => MoreOptionHandler(row.code)}
                />
             
            )}
          </div>
        </div>
      ) : null}
      <InValidAccess isShow={isAccessible} clickHandler={onClose} />
    </>
  );
}